import { getStyles as e } from "./style.js";
import { cn as t } from "../cn.js";
import { createContext as n, forwardRef as r, useContext as i } from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Tabs as s } from "@ark-ui/react/tabs";
// src/design/tabs/index.tsx
var c = n({}), l = (e, t) => {
	let n = i(c);
	return {
		variant: e ?? n.variant ?? "line",
		size: t ?? n.size ?? "sm"
	};
}, u = ({ children: n, className: r, orientation: i = "horizontal", variant: o, size: l, ...u }) => /* @__PURE__ */ a(c.Provider, {
	value: {
		variant: o,
		size: l
	},
	children: /* @__PURE__ */ a(s.Root, {
		className: t(e().root({ orientation: i }), r),
		orientation: i,
		...u,
		children: n
	})
}), d = r(({ children: n, className: r, variant: i, size: o, orientation: c = "horizontal", ...u }, d) => {
	let { variant: f, size: p } = l(i, o);
	return /* @__PURE__ */ a(s.List, {
		ref: d,
		className: t(e().list({
			variant: f,
			size: p,
			orientation: c
		}), r),
		...u,
		children: n
	});
});
d.displayName = "TabsList";
var f = r(({ className: n, variant: r, orientation: i = "horizontal", ...o }, c) => {
	let { variant: u } = l(r);
	return /* @__PURE__ */ a(s.Indicator, {
		ref: c,
		className: t(e().indicator({
			variant: u,
			orientation: i
		}), n),
		...o
	});
});
f.displayName = "TabsIndicator";
var p = r(({ children: n, className: r, variant: i, size: o, orientation: c = "horizontal", asChild: u, ...d }, f) => {
	let { variant: p, size: m } = l(i, o);
	return /* @__PURE__ */ a(s.Trigger, {
		ref: f,
		className: t(e().trigger({
			variant: p,
			size: m,
			orientation: c
		}), r),
		asChild: u,
		...d,
		children: u ? n : /* @__PURE__ */ a("span", {
			className: "flex items-center justify-center gap-2",
			children: n
		})
	});
});
p.displayName = "TabsTrigger";
var m = r(({ children: n, className: r, variant: i, size: o, orientation: c = "horizontal", href: u, asChild: d, ...f }, p) => {
	let { variant: m, size: h } = l(i, o), g = t(e().trigger({
		variant: m,
		size: h,
		orientation: c
	}), r);
	return d ? /* @__PURE__ */ a(s.Trigger, {
		ref: p,
		asChild: !0,
		className: g,
		...f,
		children: n
	}) : /* @__PURE__ */ a(s.Trigger, {
		asChild: !0,
		className: g,
		...f,
		children: /* @__PURE__ */ a("a", {
			ref: p,
			href: u,
			children: /* @__PURE__ */ a("span", {
				className: "flex items-center justify-center gap-2",
				children: n
			})
		})
	});
});
m.displayName = "TabsLinkTrigger";
var h = r(({ children: n, className: r, variant: i, size: o, orientation: c = "horizontal", ...u }, d) => {
	let { variant: f, size: p } = l(i, o);
	return /* @__PURE__ */ a(s.Content, {
		ref: d,
		className: t(e().content({
			variant: f,
			size: p,
			orientation: c
		}), r),
		...u,
		children: /* @__PURE__ */ a("div", {
			className: "animate-in fade-in slide-in-from-bottom-2 duration-slow ease-enter",
			children: n
		})
	});
});
h.displayName = "TabsContent";
var g = ({ tabs: e, defaultValue: t, variant: n = "line", size: r = "sm", orientation: i = "horizontal", showIndicator: s = !0, className: c, ...l }) => /* @__PURE__ */ o(u, {
	defaultValue: t || e[0]?.value,
	variant: n,
	size: r,
	orientation: i,
	className: c,
	...l,
	children: [/* @__PURE__ */ o(d, {
		variant: n,
		size: r,
		orientation: i,
		children: [e.map((e) => e.href ? /* @__PURE__ */ a(m, {
			value: e.value,
			href: e.href,
			disabled: e.disabled,
			variant: n,
			size: r,
			orientation: i,
			children: e.label
		}, e.value) : /* @__PURE__ */ a(p, {
			value: e.value,
			disabled: e.disabled,
			variant: n,
			size: r,
			orientation: i,
			children: e.label
		}, e.value)), s && (n === "line" || n === "pills" || n === "solid") && /* @__PURE__ */ a(f, {
			variant: n,
			orientation: i
		})]
	}), e.map((e) => /* @__PURE__ */ a(h, {
		value: e.value,
		variant: n,
		size: r,
		orientation: i,
		children: e.content
	}, e.value))]
}), _ = s.Context, v = () => null;
v.Root = u, v.List = d, v.Indicator = f, v.Trigger = p, v.LinkTrigger = m, v.Content = h, v.Default = g, v.Context = _, v.getStyles = e;
export { v as Tabs };

//# sourceMappingURL=index.js.map